import React, { Component } from "react";
import {
  pickKeyMarketAvgsRowForArea,
  getSortedKmaBoxes,
  getKmaHeaderFields,
  getKmaDurationLabel,
  formatKmaAreaDuration,
  normalizeKmaDurationValue,
  hasKmaBoxValue,
  formatKmaBoxValue,
  getBoxKey,
} from "./hotBoxesJuneUtils";

class HotBoxesJunePrint extends Component {
  componentDidMount() {
    require("./print.scss");
  }

  render() {
    const { keyMarketAvgsList, currentArea } = this.props;
    const kmaRow = pickKeyMarketAvgsRowForArea(keyMarketAvgsList, currentArea);
    const boxes = getSortedKmaBoxes(kmaRow);
    const { title, subtitle, tagLine } = getKmaHeaderFields(kmaRow, currentArea);
    const selectedDuration = normalizeKmaDurationValue(
      kmaRow?.kmaAreaDuration || kmaRow?.kmaDuration || "6m",
    );
    const durationLabel =
      (kmaRow && getKmaDurationLabel(kmaRow)) ||
      formatKmaAreaDuration(selectedDuration);

    return (
      <div className="print-hot-boxes-june">
        <header className="hot-boxes-june-header">
          <h1 className="hot-boxes-june-title">{title}</h1>
          {subtitle ? (
            <h2 className="hot-boxes-june-subtitle">{subtitle}</h2>
          ) : null}
        </header>

        <div className="hot-boxes-june-meta">
          <div className="hot-boxes-june-meta-left-wrap">
            {tagLine ? (
              <p className="hot-boxes-june-meta-left">{tagLine}</p>
            ) : (
              <p className="hot-boxes-june-meta-left" aria-hidden="true" />
            )}
          </div>
          <div className="hot-boxes-june-meta-right-wrap">
            {durationLabel ? (
              <p className="hot-boxes-june-meta-right">{durationLabel}</p>
            ) : null}
          </div>
        </div>

        <div className="hot-boxes-june-columns-wrapper">
          <div className="hot-boxes-june-columns">
            {boxes.map((box) => (
              <div className="hot-boxes-june-column" key={getBoxKey(box)}>
                {hasKmaBoxValue(box) ? (
                  <p className="hot-boxes-june-stat-value">
                    {formatKmaBoxValue(box)}
                  </p>
                ) : (
                  <p
                    className="hot-boxes-june-stat-value hot-boxes-june-stat-value-empty"
                    aria-hidden="true"
                  />
                )}
                {box.kmaTitle ? (
                  <p className="hot-boxes-june-stat-label">{box.kmaTitle}</p>
                ) : null}
                {box.kmaText ? (
                  <p className="hot-boxes-june-stat-description">
                    {box.kmaText}
                  </p>
                ) : null}
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default HotBoxesJunePrint;
